<video autoplay loop controls class="clip_video">
    <source [src]="urlSafe" type="video/mp4">
    Your browser does not support the video tag.
</video>